import React from 'react';
import { Col, Row } from 'react-bootstrap';

const Summer = () => {
    return (
        <Row className="my-4 p-4 Summerrow d-flex justify-content-center align-items-center">
            <Col  className="p-4 weddingcolam"  lg={5} md={10} sm={12}>
                <h1 className="weddingtitle text-center springtxt">Summer Flowers</h1>
            </Col>
        </Row>
    );
};

export default Summer;